import { createContext } from 'react';

const WaitListToggle = createContext(null);

export default WaitListToggle;
